/* eslint-disable @next/next/no-img-element */
import { useState, useEffect } from 'react';
import http from 'utilities/http';
import Tag from "components/cong-dong/chi-tiet/image-tag";
import isEmpty from 'lodash/isEmpty';
import Slider from "react-slick";
import ModalTagImage from 'components/tao-bai-viet/noi-dung/image/modalTagImage';
import { formatSku, getUrlName } from 'utilities/helper';
import isEqual from 'lodash/isEqual';

export default function SlideImage({ image: imageP, isCreate = false, imageId = null, thumbnail_file_id = null, setThumbnail = null, isOwn = false, noMarginTop = false }) {
    const [isTagDisplay, setIsTagDisplay] = useState(true);
    const [tagShowingId, setTagShowingId] = useState(null);
    const [displayModalTag, setDisplayModalTag] = useState(false);
    const [image, setImage] = useState(imageP);

    const fetchMyImageById = async (id) => {
        const res = await http(`community/my-files?id=${id}`, {}, { token: 'Bearer ' + getCookie(TOKEN_CONGDONG) }, 'v2');
        if (res.success == true && !isEmpty(res.data)) {
            setImage(res.data[0]);
        }
    };

    useEffect(() => {
        if (!isEqual(imageP, image)) {
            setImage(imageP);
            return;
        };
    }, [imageP]);

    useEffect(() => {
        if (imageId) {
            fetchMyImageById(imageId);
            return;
        }
    }, [imageId]);

    const switchTagEnable = () => {
        setIsTagDisplay(!isTagDisplay);
    };

    const settingsDetail2 = {
        speed: 500,
        slidesToShow: 7,
        infinite: false,
        slidesToScroll: 1,
        adaptiveHeight: true,
        arrows: true,
        dots: false,
        focusOnSelect: false,
        swipeToSlide: true,
        responsive: [
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 5,
                }
            },
        ]
    };

    const datAnhBia = () => {
        if (thumbnail_file_id === image.id) return;
        setThumbnail({ thumbnail_file_id: image.id });
    };

    return (
        <>
            <div className={noMarginTop ? "photoGallery-large" : "photoGallery-large mt-3"}>
                <div className='text-center w-100'>
                    <img src={image.storage_url} alt="" className='mb-2' />
                </div>
                {
                    (image.content || image.description) && <div className='text-center'>
                        <i>{image.content || image.description}</i>
                    </div>
                }
                {!isCreate && !isEmpty(image['tagged_products']) && image['tagged_products'].some(x => x.type != 'similar') && <div className="photoGallery-switch mb-2">
                    <div className="switch">
                        <label className="switch-label">
                            <input className={isTagDisplay ? "switch-checkbox active" : "switch-checkbox"} value={isTagDisplay} onChange={switchTagEnable} type="checkbox" />
                            <span className="switch-round"></span>
                        </label>
                    </div>
                </div>}
                {isTagDisplay && image['tagged_products'].map((tag, index) => {
                    if (isEmpty(tag.position)) return <></>;
                    return <Tag key={`${image.id}` + index} id={`${image.id}` + index} tag={tag} tagShowingId={tagShowingId} setTagShowingId={setTagShowingId} />;
                })}
                {/* {(isCreate || (!isCreate && stateStore.profileCommunity?.id === image.tagged_products[0].user.id) ) && <div className="createPost-btn"> */}
                {(isCreate || isOwn) && <div className="createPost-btn tag-btn">
                    {isCreate && <button
                        className={thumbnail_file_id !== image.id ? "btn btn--white" : "btn btn--blue"}
                        style={thumbnail_file_id !== image.id ? { backgroundColor: 'rgba(0,0,0,0.1)' } : {}}
                        onClick={datAnhBia}
                    >{thumbnail_file_id === image.id ? 'Ảnh bìa' : 'Đặt ảnh bìa'}</button>}

                    {(isCreate || isOwn) && <button className="btn btn--blue"
                        onClick={() => {
                            setDisplayModalTag(true);
                            // if (imageTag.id != image.id) settaggedProduct([]);
                            // setImageTag(image);
                        }}>
                        <img src="/images/Bookmark-white.svg" alt="" className="mr-1" style={{ width: 14 }} width={14} height={14} />Tag sản phẩm
                    </button>}
                </div>}
            </div>
            {!isEmpty(image.tagged_products) && <div className="slider slider-sub-small slider-sub">
                <Slider {...settingsDetail2}>
                    {
                        image.tagged_products.map((img, index) => {
                            return <div className="product-tag-small" key={'' + img.sku + index} title={img.name}>
                                <a target="_blank" href={`/shop/${formatSku(img.sku)}/${getUrlName(img.name)}.html`} rel="noreferrer">
                                    <div key={index} className="photoGallery-small wrap-next-image">
                                        {/* <img src={img.avatar_url} alt="" /> */}
                                        <img layout="fill" src={img.avatar_url} alt={img.name} />
                                    </div>
                                    {img.type == 'similar' && <div className="tuong-tu"><p>Tương tự</p></div>}
                                </a>
                            </div>;
                        })
                    }
                </Slider>
            </div>}
            <ModalTagImage displayModalTag={displayModalTag} setDisplayModalTag={setDisplayModalTag} imageTag={image} setImage={setImage} />
        </>
    );
};